exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* ---------- COLORS ----------*/\n.xs-chip {\n  display: inline;\n}\n.xs-chip .xs-chip-label {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.xs-chip .xs-chip-label .xs-chip-circle {\n  border-radius: 4px;\n  height: 8px;\n  margin-right: 6px;\n  width: 8px;\n}\n.xs-chip .xs-chip-delete-icon {\n  color: #22232c;\n  padding: 0 5px;\n}\n.xs-chip div.errorText {\n  color: #ff0000;\n}\n", ""]);

// exports
